import {
  ANALYTICS_COOKIE_PATTERNS,
  MARKETING_COOKIE_PATTERNS,
  CONSENT_COOKIE_NAME,
} from '@/constants/cookie';

export function setCookie(name: string, value: string, days: number): void {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  const secure = window.location.protocol === 'https:' ? ';Secure' : '';
  document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=/;SameSite=Lax${secure}`;
}

export function getCookie(name: string): string | null {
  const nameEq = `${name}=`;
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const trimmed = cookie.trim();
    if (trimmed.startsWith(nameEq)) {
      return decodeURIComponent(trimmed.substring(nameEq.length));
    }
  }
  return null;
}

export function deleteCookie(name: string): void {
  const domains = [
    '', // current domain
    `.${window.location.hostname}`,
    window.location.hostname,
  ];

  // Also try the root domain (e.g., .verdea.app from www.verdea.app)
  const parts = window.location.hostname.split('.');
  if (parts.length > 2) {
    domains.push(`.${parts.slice(-2).join('.')}`);
  }

  for (const domain of domains) {
    const domainPart = domain ? `;domain=${domain}` : '';
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/${domainPart}`;
    document.cookie = `${name}=;max-age=0;path=/${domainPart}`;
  }
}

function deleteCookiesByPatterns(patterns: string[]): void {
  const allCookies = document.cookie.split(';');
  for (const cookie of allCookies) {
    const name = cookie.trim().split('=')[0];
    if (!name || name === CONSENT_COOKIE_NAME) continue;

    const shouldDelete = patterns.some((pattern) => name.startsWith(pattern));
    if (shouldDelete) {
      deleteCookie(name);
    }
  }
}

export function deleteAnalyticsCookies(): void {
  deleteCookiesByPatterns(ANALYTICS_COOKIE_PATTERNS);
}

export function deleteMarketingCookies(): void {
  deleteCookiesByPatterns(MARKETING_COOKIE_PATTERNS);
}
